export const chartLabels = Array.from({ length: 200 }, (_, i) => (i * 0.03).toFixed(2));

export const chartOptions = {
  legend: {
    display: false,
  },
  elements: {
    line: {
      tension: 0.4,
    },
  },
  scales: {
    xAxes: [
      {
        id: "x-axis-1",
        scaleLabel: {
          display: true,
          labelString: "t",
          fontStyle: "bold",
        },
      },
    ],
    yAxes: [
      {
        scaleLabel: {
          display: true,
          labelString: "h(t)",
          fontStyle: "bold",
        },
      },
    ],
  },
};

export const chartAnnotations = {
  type: "line",
  display: true,
  scaleID: "x-axis-1",
  value: 0,
  borderColor: "rgba(0, 0, 128, 1)",
  borderWidth: 3,
};
